import * as Yup from 'yup';
import {
  DASHBOARD_ENDPOINTS,
  IDENTITY_ENDPOINTS,
  PAYMENT_COLLECTION_ENDPOINTS,
  GAP_WAIVER_ENDPOINTS
} from './endpoints';
import { DashboardSummary, IdentityPayload, IdentityResponse, GapWaiverEligibility } from './types';
import axios from '|/helpers/axios';

export const getIdentity = (signal?: AbortSignal): Promise<IdentityResponse> =>
  axios
    .get<IdentityResponse>(IDENTITY_ENDPOINTS.IDENTITY_BASE, {
      signal
    })
    .then(res => res.data);

export const submitIdentityDetails = (
  payload: IdentityPayload,
  signal?: AbortSignal
): Promise<IdentityResponse> =>
  axios
    .post<IdentityResponse>(IDENTITY_ENDPOINTS.IDENTITY_BASE, payload, {
      headers: {
        'Content-Type': 'application/json'
      },
      signal
    })
    .then(res => res.data);

const plaidLinkTokenResponseSchema = Yup.object().shape({
  link_token: Yup.string().required()
});

export const getPlaidLinkToken = async () =>
  axios
    .get(PAYMENT_COLLECTION_ENDPOINTS.GET_PLAID_LINK_TOKEN)
    .then(response => response.data as unknown)
    .then(responseData => plaidLinkTokenResponseSchema.validate(responseData));

export const getGapWaiverEligibility = async (
  abortSignal: AbortSignal
): Promise<GapWaiverEligibility> => {
  return axios
    .get<GapWaiverEligibility>(GAP_WAIVER_ENDPOINTS.GET_ELIGIBILITY, {
      signal: abortSignal
    })
    .then(res => res.data);
};

export const resetGapWaiver = async (abortSignal: AbortSignal): Promise<void> => {
  return axios
    .post<never>(GAP_WAIVER_ENDPOINTS.RESET, undefined, {
      signal: abortSignal
    })
    .then(() => undefined);
};

export const declineGapWaiver = async (abortSignal: AbortSignal): Promise<void> => {
  return axios
    .post<never>(GAP_WAIVER_ENDPOINTS.DECLINE, undefined, {
      signal: abortSignal
    })
    .then(() => undefined);
};

export const getDashboardSummary = (signal?: AbortSignal): Promise<DashboardSummary | null> =>
  axios
    .get<DashboardSummary>(DASHBOARD_ENDPOINTS.GET_DASHBOARD_SUMMARY, { signal })
    .then(res => (res.status === 204 ? null : res.data));
